import { GoogleAnalytics } from "@directv-digital/dds.services.analytics-service";
import { ButtonPanelProps } from "@directv-digital/dds.ui.button-panel";
import { IDtvButtonAnalytics, IDtvButtonProps } from "@directv-digital/dds.ui.dtv-button";
import { IDtvTextProps } from "@directv-digital/dds.ui.dtv-text";

export const planCardColorVariant = {
  lapis: {
    bar: "#2E70BD",
    background: "#F2FBFF",
    dropShadow: "#2E70BD66"
  },
  sun: {
    bar: "#E88534",
    background: "#FFFAF6",
    dropShadow: "#E8853466"
  },
  jet: {
    bar: "#21528C",
    background: "#ECF3FB",
    dropShadow: "#21528C"
  },
  amethyst: {
    bar: "#7A267B",
    background: "#FCF2FD",
    dropShadow: "#7A267B"
  },
  gray: {
    bar: "#555555",
    background: "#F4F4F4",
    dropShadow: "#E4E4E4" // 10% of 555555
  }
} as Record<
    PlanCardColorVariantType, { bar: string; background: string; dropShadow: string }
  >;

export type PlanCardColorVariantType =
  | "lapis"
  | "sun"
  | "jet"
  | "amethyst"
  | "gray";

export enum PackageVariant {
  v1 = "package-card",
  v2 = "progressive-package-card",
}

export const defaultPackageVariant =
  "package-card";

export enum PackageModuleVariant {
  v1 = "package-card",
  v2 = "toggle-package-card",
}

export interface PackageChannel {
  url?: string;
  alt?: string;
}

export interface IPlanCardSets {
  locals: IPlanCardData[];
  noLocals?: IPlanCardData[];
  satelliteLocals?: IPlanCardData[];
  satelliteNoLocals?: IPlanCardData[];
}

export interface IPlanCardData {
  variant?: PlanCardColorVariantType;
  backgroundColor?: string;
  queryparam?: string;
  backgroundColorRight?: string;
  barColor?: string;
  cardFontColor?: string;
  googleAnalytics?: GoogleAnalytics & IDtvButtonAnalytics;

  /** Topper */
  topper?: any;
  disableAutoTopper?: boolean;
  rewardTextColor?: string;

  /** Top Section */
  productName?: IDtvTextProps;
  channels?: PackageChannel[];
  seeAllChannelsCta?: IDtvButtonProps;
  seeAllChannelsSecondCta?: IDtvButtonProps;
  ribbon?: {
    content?: string;
    textColor?: string;
    cta?: IDtvButtonProps;
    ctaColor?: string;
    bgColor?: string;
  }

  /** Pricing/Body */
  productDesc?: IDtvTextProps;
  productPrice?: {
    priceLabel?: IDtvTextProps;
    strikeoutPrice?: IDtvTextProps & { moddedContent?: string };
    price?: IDtvTextProps & { moddedContent?: string };
    priceCopy?: (IDtvTextProps & { moddedContent?: string })[]; // modded content includes dynamic values
    totalPriceNum?: number | null; // added as reference for analytics
  };

  pricingData?: {
    useRsnFee: boolean;
    rsnFee: number | null;
    offerSubtotal: number;
    extOfferSubtotal: number;
    /** Optional data CI provided if all else fails! */
    geminiFee?: number;
    customFees?: number[];
  };

  /** Ctas */
  cta?: IDtvButtonProps;
  ctaPanel?: ButtonPanelProps;
  pkgUrl?: string;
  optionalCTA?: IDtvButtonProps;
  comparePackagesCta?: any;
  whatYouGet?: any;
  legalContent?: string;

  /** non-progressivbe package card */
  featureHeading?: string;
  features?: IDtvTextProps[];

  /** embedded Svods */
  embeddedSvods?: any;
  packageId?: string;
}
